import CloseIcon from '@mui/icons-material/Close';
import React from 'react';

import { ButtonProps } from 'common/components/material/Button';
import { NavBtnSizeType, StyledNavButton, StyledNavIcon } from './styles';

const StyledCloseIcon = StyledNavIcon(CloseIcon);

type CloseButtonProps = ButtonProps & {
  size?: NavBtnSizeType;
  clickHandler?: (e: React.MouseEvent | React.KeyboardEvent) => void;
};

const CloseButton: React.FC<CloseButtonProps> = ({
  size = 'medium',
  clickHandler,
  ...buttonProps
}) => {
  const handleClick = (e: React.MouseEvent | React.KeyboardEvent) => {
    clickHandler && clickHandler(e);
    return;
  };

  return (
    <StyledNavButton
      size={size}
      startIcon={<StyledCloseIcon size={size} />}
      onClick={handleClick}
      variant="outlined"
      {...buttonProps}
    ></StyledNavButton>
  );
};

export default CloseButton;
